import { useEffect, useRef, useState } from "react";
import { ugcAPI } from "../../lib/api";

// Debounced live check of whether the UGC script fits the chosen video length
export function useScriptFit(payload, enabled = true) {
  const [fit, setFit] = useState(null);
  const [checking, setChecking] = useState(false);
  const key = JSON.stringify(payload);
  const latest = useRef(key);

  useEffect(() => {
    latest.current = key;
    if (!enabled || !payload.script?.trim()) {
      setFit(null);
      setChecking(false);
      return undefined;
    }
    setChecking(true);
    const timer = setTimeout(async () => {
      try {
        const result = await ugcAPI.checkScriptFit(payload);
        if (latest.current === key) setFit({ ...result, key });
      } catch {
        if (latest.current === key) setFit(null);
      } finally {
        if (latest.current === key) setChecking(false);
      }
    }, 600);
    return () => clearTimeout(timer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, enabled]);

  const checkNow = async () => {
    if (fit && fit.key === key) return fit;
    const result = await ugcAPI.checkScriptFit(payload);
    const fresh = { ...result, key };
    setFit(fresh);
    return fresh;
  };

  return { fit: fit && fit.key === key ? fit : null, checking, checkNow };
}
